class ProductCustomizer extends HTMLElement {
  constructor() {
      super();
      this.selectors = this.querySelectorAll("[data-selector]")
      if(!this.selectors) return

      this.itemsLength = 0

      this.initOptionSelectors()
      this.initProductAdding()
      this.addEventListener("updateTotal", () => {
          this.updateTotalPrice()
      })
      this.initBuyingForm()

  }
  updateTotalPrice(){
      const lineItems =  this.querySelectorAll("customizer-line-item:not([removing])")

      this.classList.toggle("is-empty", lineItems.length == 0)

      if (lineItems.length == 0) return;

      const amount = [...lineItems].reduce((total, num) => {
          return total + num.getPrice();
      }, 0)

      this.totalElem = this.totalElem || this.querySelector("[data-total]")
      this.totalElem.innerHTML = window.Shopify.formatMoney(amount)
  }
  initProductAdding(){
      this.addingTrigger = this.querySelector("[data-add-product]")
      const {selector: selectorName} = [...this.selectors].at(-1).dataset
      if(!this.addingTrigger || selectorName !== "design") return

      this.addingTrigger.addEventListener("click", this.addingProduct.bind(this))
  }
  async addingProduct(){
      this.addingTrigger.classList.add("disabled")
      const {value: productHandle} = [...this.selectors].at(-1).dataset

      try{
          let response = await fetch(`${window.location.origin}/products/${productHandle}?section_id=customizer-line-item-ajax&logo_product=${this.selectorsData.logoProduct.handle}`)
          response = await response.text()

          this.itemsCount = this.itemsCount || 1
          response = response
              .replaceAll("{formId}", this.dataset.formId)
              .replaceAll("{logo_product_index}", this.itemsCount)
              .replaceAll("{line_item_index}", ++this.itemsCount)

          ++this.itemsCount

          if(this.checkMaxValueLineItem(productHandle)) {
              this.addingTrigger.classList.remove("disabled")
              return
          }

          const html = new DOMParser().parseFromString(response, 'text/html');

          const lineItemElem = html.querySelector("customizer-line-item")
          this.lineItemsWrapper = this.lineItemsWrapper || this.querySelector(".product-customizer__line-items")

          if(!this.lineItemsWrapper || !lineItemElem) return
          this.lineItemsWrapper.append(lineItemElem)

          this.updateTotalPrice()
          this.addingTrigger.classList.remove("disabled")
          const lineItemSettingsElem = html.querySelector("customizer-line-item-settings")
          this.lineItemsSettingsWrapper = this.lineItemsSettingsWrapper || this.querySelector(".product-customizer__settings-line-items")

          if(!this.lineItemsSettingsWrapper || !lineItemSettingsElem) return
          this.lineItemsSettingsWrapper.append(lineItemSettingsElem)

      }
      catch (e) {
          console.error(e)
      }
  }
  checkMaxValueLineItem(handle){
      const productLinesQuantity = document.querySelectorAll(`customizer-line-item[data-product=${handle}] [data-line-item-quantity]`)
      if(productLinesQuantity.length == 0) return false

      const maxValue = [...productLinesQuantity][0].max
      const allQuantity = [...productLinesQuantity].reduce((total, input) => {
          return total + +input.value;
      }, 0)
      return allQuantity >= maxValue
  }
  initOptionSelectors(){
      this.selectorsData = this.getSelectorData()
      if(!this.selectorsData) return

      console.log("this.selectorsData", this.selectorsData)
      this.selectors = [...this.selectors]
      this.selectors.forEach(selector => {
          selector.addEventListener("click", (event)=>{
              if(window.innerWidth <= 678) {
                  selector.classList.toggle("open", !selector.classList.contains("open"))
                  this.selectors.forEach(subselector => {
                      if (subselector != selector) subselector.classList.remove("open")
                  })
              }

              if(!event.target.closest("[data-selector-option]")) return

              const optionsWrapper = event.target.closest(".selector__options-container")

              if(window.innerWidth > 678) {
                  optionsWrapper.classList.add("hidden")
                  setTimeout(() => {
                      optionsWrapper.classList.remove("hidden")
                  }, 100)
              }

              const {
                  dataset: {value: value},
                  outerHTML: content
              } = event.target.closest("[data-selector-option]")

              const selectedOption = selector.querySelector(".selector__selected")

              selectedOption.innerHTML = content.replace('data-selector-option=""', "")
              selector.setAttribute("data-value", value)


              const selectorIndex = this.selectors.indexOf(selector) + 1
              if(!this.selectors[selectorIndex]) return;
              this.updateSelectors(this.selectors[selectorIndex])
          })
      })
  }
  updateSelectors(selector){
      let isValid = true
      const [type, model] = [...this.selectors].map(selector => selector.dataset.value)
      const {structure: structure} = this.selectorsData
      let itemInfoPrefix = selector.dataset.selector == "design" ? "product-" : ""

      let items = selector.dataset.selector == "design" ?
          structure[type][model]
          :
          structure[type].collections.filter(collection => structure[type][collection].length > 0)

      if(items.length == 0) {
          if(selector.dataset.selector != "model") return;
          items = structure[type].products
          itemInfoPrefix = "product-"
          selector.classList.add("hidden")
          isValid = false
      }
      items = items.map(item => {return {
          image: this.selectorsData.itemsInfo[`${itemInfoPrefix}${item}`].image,
          title: this.selectorsData.itemsInfo[`${itemInfoPrefix}${item}`].title,
          value: item
      }})

      if (selector.dataset.selector == "model" && !isValid){
          const productsSelector = [...this.selectors].at(-1)
          this.updateSelectorContent(items, productsSelector)
          return;
      }
      selector.classList.remove("hidden")

      this.updateSelectorContent(items, selector)

      const selectorIndex = this.selectors.indexOf(selector) + 1
      if(!this.selectors[selectorIndex]) return;
      this.updateSelectors(this.selectors[selectorIndex])
  }
  updateSelectorContent(items, selector){
      const optionPattern = this.querySelector('[data-pattern="selector-option"]').innerHTML
      const {children: [selected]} = selector
      const options = selector.querySelector(".selector__options-wrapper")

      selector.setAttribute("data-value", items[0].value)

      selected.innerHTML = optionPattern.replace("data-selector-option", "")
          .replace("{value}", items[0].value)
          .replace("{image_url}", items[0].image)
          .replace("{title}", items[0].title)

      options.innerHTML = items.map(item => {
          return optionPattern.replace("{value}", item.value)
              .replace("{image_url}", item.image)
              .replace("{title}", item.title)
      }).join("")
  }
  getSelectorData(){
      try{
          const jsonElem = document.querySelector(`#OptionsData-${this.dataset.sectionId}`)
          if(!jsonElem) return

          return JSON.parse(jsonElem.innerHTML)
      }catch (e) {
          console.error(e)
      }
  }

  fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  initBuyingForm(){
      this.form = this.querySelector("form")
      this.buttonSubmit = this.querySelector(".product-form__submit")
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }
  async onSubmitHandler(evt) {
      evt.preventDefault();

      this.buttonSubmit.classList.add("disabled")
      await fetch('/cart/clear.js', {
          method: 'POST',
      })

      const config = this.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      config.body = formData;

      let response = await fetch(`/cart/add.js`, config)
      response = await response.json()

      window.location.href= "/checkout"
  }

}
customElements.define('product-customizer', ProductCustomizer);



class CustomizerLineItem extends HTMLElement {
  constructor() {
      super();

      this.initChangeQuantity()
  }

  initChangeQuantity(){
      this.quantity = this.quantity || 1
      this.querySelectorAll(".quantity__button").forEach(button => {
          const coefficient = button.name == "minus" ? -1 : 1
          button.addEventListener("click", this.handleUpdateQuantity.bind(this, coefficient))
      })

      this.querySelector("[data-remove]")?.addEventListener("click", this.removeLineItem.bind(this))
  }
  handleUpdateQuantity(step){
      this.settingsElem = this.settingsElem || document.querySelector(`[data-line-item-id="${this.dataset.position}"]`)
      this.quantityInput = this.quantityInput || this.querySelector(".quantity__input")

      const productLinesQuantity = document.querySelectorAll(`customizer-line-item[data-product=${this.dataset.product}] [data-line-item-quantity]`)
      const allQuantity = [...productLinesQuantity].reduce((total, input) => {
          return total + +input.value;
      }, 0)

      console.log("allQuantity", allQuantity + step)

      if (allQuantity + step > this.quantityInput.max) return;

      const prevValue = this.quantityInput.value

      this.quantityInput.stepUp(step)

      if(this.quantityInput.value == 0) this.removeLineItem()

      if(prevValue == this.quantityInput.value) return

      this.quantity = this.quantityInput.value
      this.settingsElem?.dispatchEvent(new CustomEvent('updateQuantity', {
          detail: {quantity: this.quantityInput.value}}))


      this.settingsElem = this.settingsElem || document.querySelector(`[data-line-item-id="${this.dataset.position}"]`)
      this.closest("product-customizer")?.dispatchEvent(new CustomEvent('updateTotal'))
  }

  removeLineItem(){
      this.setAttribute("removing", "true")
      this.settingsElem = this.settingsElem || document.querySelector(`[data-line-item-id="${this.dataset.position}"]`)
      this.closest("product-customizer")?.dispatchEvent(new CustomEvent('updateTotal'))

      this.settingsElem?.remove()
      this.remove()
  }
  getPrice(){
      this.settingsElem = this.settingsElem || document.querySelector(`[data-line-item-id="${this.dataset.position}"]`)

      const priceLogoProduct = this.settingsElem?.getPrice() || 0

      return( (+priceLogoProduct + +this.dataset.price) * this.quantity)
  }
}
customElements.define('customizer-line-item', CustomizerLineItem);


class CustomizerLineItemSettings extends HTMLElement {
  constructor() {
      super();
      this.initLogoUploader()
      this.addEventListener("updateQuantity",(event)=>this.updateQuantity.call(this, event))
  }
  updateQuantity(event){
      const quantity = event.detail.quantity

      this.querySelectorAll("[data-line-item-quantity]").forEach(quantityElem => {
          quantityElem.tagName == "INPUT" ?
          quantityElem.value = quantity :
              quantityElem.innerHTML = quantity
      })
  }
  initLogoUploader(){
      const valueElem = this.querySelector("[data-logo-value]")
      this.querySelector("[data-logo-storage]").addEventListener("change", (event)=> {
          valueElem.innerHTML = event.target.files.length > 0 ?
              event.target.files[0].name : ""

          this.querySelectorAll("[data-logo-product]").forEach(input=>{
              event.target.files.length > 0 ?
                  input.setAttribute("form", this.dataset.formId) :
                  input.removeAttribute("form")
          })

          this.uncludedLogo = event.target.files.length > 0

          this.settingsElem = this.settingsElem || document.querySelector(`[data-line-item-id="${this.dataset.position}"]`)
          this.closest("product-customizer")?.dispatchEvent(new CustomEvent('updateTotal'))
      })
  }
  getPrice(){
      return this.uncludedLogo ? this.dataset.price : 0
  }
}
customElements.define('customizer-line-item-settings', CustomizerLineItemSettings);
